import FocusErrorProcessLicense from './FocusErrorProcessLicense';

export default FocusErrorProcessLicense;
